import * as React from "react";
import { Block } from "../Block";

/**
 * Container to add side padding
 */

const SidePadder: React.FC = ({ children }) => (
  <Block paddingLeft="scale800" paddingRight="scale800">
    {children}
  </Block>
);

export { SidePadder };
